import { useMemo } from "react";
import { ModifyDetail } from "../../../../redux/apiSpecifications/apiSubjects";
import { useTranslation } from "react-i18next";

type SubjectDeletedAddressDescriptionDetails = {
  address_type: string;
  address: string;
};

interface ISubjectDeletedAddressDescriptionProps {
  modifyDetailsJson: ModifyDetail[];
}

const SubjectDeletedAddressDescription = ({modifyDetailsJson}: ISubjectDeletedAddressDescriptionProps) => {
  const { t } = useTranslation();
  
    const getAddressType = (code: string): string => {
      const translations: Record<string, string> = {
        D: t("address-type-D"),
        R: t("address-type-R"), 
        S: t("address-type-S"),
        L: t("address-type-L"),
        O: t("address-type-O"),
        A: t("address-type-A"),
      };
    
      return translations[code] || code;
    };
  
    const subjectAddressDescriptionDetails: SubjectDeletedAddressDescriptionDetails =
    useMemo(() => {
      return {
        address_type: getAddressType(
          modifyDetailsJson.find((_) => _.key === "address_type")?.value ?? ""
        ),
        address: modifyDetailsJson.find((_) => _.key === "address")?.value ?? "",
      };
    }, [modifyDetailsJson, t]);

  return (
    <> {t("HISTORY-TEMPLATES.policy-subject-deleted-address-description", {
      address_type: subjectAddressDescriptionDetails.address_type,
      address: subjectAddressDescriptionDetails.address,
    })}</>
  )
}
export default SubjectDeletedAddressDescription